import { CivilStatus } from '__generated__/api';
import i18n from 'i18next';

const getMaritalStatusValue = (maritalStatus?: CivilStatus | undefined) =>
  maritalStatus ? i18n.t(`general.enumerations.maritalStatus.${maritalStatus}`) : undefined;

export default getMaritalStatusValue;
